module.exports = __webpack_public_path__ + "static/img/key4lead_logo_image_white_background.a1b8b77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/key4lead_logo_image_white_background.png
// module id = BviG
// module chunks = 1